export default __webpack_public_path__ + "static/media/settings-inactive.9e6b229b.png";